import type { ReactNode } from 'react';

export const symbol_view_comfy: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-220v-520q0-24.75 17.63-42.38Q115.25-800 140-800h680q24.75 0 42.38 17.62Q880-764.75 880-740v520q0 24.75-17.62 42.37Q844.75-160 820-160H140q-24.75 0-42.37-17.63Q80-195.25 80-220Zm740-290v-230H140v230h680ZM383-220h437v-230H383v230Zm-243 0h183v-230H140v230Z"
		/>
	</svg>
);
